import type { NormalizedBBox } from 'features/knowledgeDocumentViewer/types/ocrViewer'

import type { NodeOverlay, PageGraphSource } from './canvasTypes'

export type NodeFocusTarget = {
  pageNumber: number
  bbox: NormalizedBBox
}

export function getNodeFocusTarget(
  pages: PageGraphSource[],
  nodeId: string
): NodeFocusTarget | undefined {
  for (const { graph, pageNumber } of pages) {
    const overlay = graph.getNode(nodeId)?.overlays[0]
    if (!overlay) continue
    const points = overlay.data.geometry.points
    const left = Math.min(...points.map(({ normalized_x }) => normalized_x))
    const top = Math.min(...points.map(({ normalized_y }) => normalized_y))
    const right = Math.max(...points.map(({ normalized_x }) => normalized_x))
    const bottom = Math.max(...points.map(({ normalized_y }) => normalized_y))
    return {
      pageNumber,
      bbox: { left, top, width: right - left, height: bottom - top },
    }
  }
  return undefined
}

export function getOverlayFocusBBox(
  overlays: NodeOverlay[],
  nodeId: string,
  imageNatural: { w: number; h: number }
): NormalizedBBox | undefined {
  const overlay = overlays.find(({ node }) => node.id === nodeId)
  if (!overlay || !imageNatural.w || !imageNatural.h) return undefined
  const xs = overlay.geometry.points.map(({ denormalized_x }) => denormalized_x)
  const ys = overlay.geometry.points.map(({ denormalized_y }) => denormalized_y)
  const left = Math.min(...xs)
  const top = Math.min(...ys)
  return {
    left: left / imageNatural.w,
    top: top / imageNatural.h,
    width: (Math.max(...xs) - left) / imageNatural.w,
    height: (Math.max(...ys) - top) / imageNatural.h,
  }
}
